import { AdminType, APIPost, APIUrl } from "api/protocols";

interface IPostLoyaltyDiscount {
    cart_id: number;
    reward_line_items: Array<{reward_id: number, cart_line_item_id: number}>;
}

export async function PostLoyaltyProgramDiscount(params?: IPostLoyaltyDiscount, useGlobalLoader?: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/cart/discount/loyalty-program"), params, useGlobalLoader);
  }